import React from "react";
import { Outlet } from "react-router";
import { Navigate, useLocation } from "react-router-dom";
import {useSelector} from "react-redux";

const Protected = () => {
  const selector = useSelector((state) => state.user?.value);
  const user = selector?.payload;
  if (!user) {
    return <Navigate to="/" replace />;
  }
  return <Outlet />;
};

export default Protected;
